import React from 'react';
import McTransferQuantityPreview from './McTransferQuantityPreview';

export default function McTransferIntelligence({ rows = [], sourceScope = '', evaluatedAt = '', orgId = '', rulesScope = sourceScope, canEditRules = false, onShowMoving = () => {}, reportItem = null, reportSite = '', reportLatestAt = '' }) {
  const source = rows.find((row) => String(row?.scope || '').trim().toLowerCase() === String(sourceScope).trim().toLowerCase());
  return <McTransferQuantityPreview key={[orgId, rulesScope, sourceScope, source?.sku || '', evaluatedAt].join(':')}
    rows={rows} sourceScope={sourceScope} orgId={orgId} rulesScope={rulesScope} canEditRules={canEditRules} onShowMoving={onShowMoving}
    reportItem={reportItem} reportSite={reportSite} reportLatestAt={reportLatestAt} />;
}
